import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { useSelector, useDispatch } from "react-redux";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import GlobalLoader from "components/common/GlobalLoader";
import { showLoader, hideLoader } from "../../../../../src/redux/slice/loaderSlice";
import { intervalToDuration, parseISO } from "date-fns";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import { useForm } from "react-hook-form";
import { clearFormData } from "../../../../../src/redux/formActions";
const getCurrentDate = () => {
  const todayDate = new Date();
  const month = String(todayDate.getMonth() + 1).padStart(2, "0");
  const year = todayDate.getFullYear();
  const date = String(todayDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${date}`;
};

export default function SuccessPreview() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, formState: { errors }, clearErrors} =
    useForm();
  const [currentDate, setCurrentDate] = useState(getCurrentDate());
  const [signError, setSignError] = useState(false);
  const loading = useSelector((state) => state.loader.loading);
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById,status,error } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );
  console.log('getInvitedUserDetailsById',getInvitedUserDetailsById);
    const {
    additionalDetails,
    addresses,
    educationDetails,
    employmentHistory,
    personalDetail,
    professionalReferences,
  } = getInvitedUserDetailsById ?? {};

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);
  useEffect(() => {
    setValue("dateAttach", getCurrentDate());
  }, []);
  useEffect(() => {
    educationDetails?.map((education, index) => {
      let uploadType = "";

      if (index === 0) {
        uploadType = "10thMarksheet";
      } else if (index === 1) {
        uploadType = "12thMarksheet";
      } else {
        uploadType = `${education.degreeName}Certificate`;
      }
      dispatch(
        fetchgetPreOnboardingDocsById({ type: uploadType, id: paramId }),
      );
    });
    employmentHistory?.map(async (education, index) => {

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `expCertFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `relievingLetterFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `offerLetter.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip1.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip2.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip3.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthBankStatement.${index}`,
          id: paramId,
        }),
      );
    });
    docTypes.forEach((type) => {
      dispatch(fetchgetPreOnboardingDocsById({ type, id: paramId }));
    });
    dispatch(
      fetchgetPreOnboardingDocsById({
        type: "passportFrontImage",
        id: paramId,
      }),
    );
    dispatch(
      fetchgetPreOnboardingDocsById({
        type: "passportLastPageImage",
        id: paramId,
      }),
    );
    dispatch(
      fetchgetPreOnboardingDocsById({ type: "illnessDocument", id: paramId }),
    );
    return () => {
      Object.values(docs).forEach((url) => {
        if (url?.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [getInvitedUserDetailsById]);



  const handleDateChange = (e) => {
    setCurrentDate(e.target.value);
  };

    const permAddrData = addresses?.find(addr => addr.addressType === "PERMANENT") || addresses?.[0] || {};
  const currAddrData = addresses?.find(addr => addr.addressType === "CURRENT") || addresses?.[1] || {};

  const formatDate = (str) => str ? new Date(str).toLocaleDateString('en-GB') : "";
  const docs = useSelector((state) => state.getPreOnboardingDocsById.docs);
  const docTypes = ["passportPhoto", "panCard", "aadhaarCard", "sign"];
  if(status==="loading")return (<div></div>);
  if(error)return;
  return (
    <div className="wrapper">
      <GlobalLoader />
      <Navbar />
      <div className="main-panel w-100">
        <div className="form-content">
          <div className="container-fluid form-navbar">
            <div className="personaldetail-form">
              <div
                className="UniversalHeadline"
                style={{ marginBottom: "5px" }}
              >
                <h6>PREVIEW</h6>
              </div>
              {/* personal detail form data */}
              <div className="personalDetailForm">
                <div className="personalDetailHeading">
                  <h6 className="personalDetailHeadline">PERSONAL DETAILS</h6>
                </div>
                <div className="preview-table">
                  <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                    <tbody>
                      <tr>
                        <td>
                          <strong>First Name:</strong>
                          <span>
                            {getInvitedUserDetailsById?.firstName || "N/A"}
                          </span>
                        </td>
                        <td>
                          <strong>Middle Name:</strong>
                          <span>
                            {getInvitedUserDetailsById?.middleName || "N/A"}
                          </span>
                        </td>
                        <td>
                          <strong>Last Name:</strong>
                          <span>
                            {getInvitedUserDetailsById?.lastName || "N/A"}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email:</strong>
                          <span>
                            {getInvitedUserDetailsById?.email || "N/A"}
                          </span>
                        </td>
                        <td>
                          <strong>Mobile:</strong>
                          <span>
                            {getInvitedUserDetailsById?.mobile || "N/A"}
                          </span>
                        </td>
                        <td>
                          <strong>Gender :</strong>
                          <span>{personalDetail?.gender || "N/A"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Mother Name :</strong>
                          <span>{personalDetail?.motherName || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Father Name :</strong>
                          <span>{personalDetail?.fatherName || "N/A"}</span>
                        </td>
                        <td>
                          <strong>UAN No :</strong>
                          <span>{personalDetail?.uanNo || "N/A"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Country :</strong>
                          <span>{permAddrData?.country || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Nationality :</strong>
                          <span>{permAddrData?.nationality || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Alternative Mob. No :</strong>
                          <span>
                            {personalDetail?.secondaryMobile || "N/A"}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Aadhar No :</strong>
                          <span>{personalDetail?.adhaarNo || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Pan No :</strong>
                          <span>{personalDetail?.panNo || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Profile photo :</strong>
                          <span>
                            {docs?.passportPhoto ? (
                              <a
                                href={docs?.passportPhoto}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Aadhar Document :</strong>
                          <span>
                            {docs?.aadhaarCard ? (
                              <a
                                href={docs.aadhaarCard}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </td>
                        <td>
                          <strong>Pan Document :</strong>
                          <span>
                            {docs?.panCard ? (
                              <a
                                href={docs.panCard}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="personalDetailForm">
                <div className="personalDetailHeading">
                  {" "}
                  <h6 className="personalDetailHeadline">
                    CONTACT DETAILS
                  </h6>{" "}
                </div>
                <h6 style={{ margin: "10px 10px -7px 10px" }}>
                  Permanent Address :
                </h6>
                <div className="preview-table">
                  <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                    <tbody>
                      <tr>
                        <td colSpan="3">
                          <strong>Address :</strong>{" "}
                          <span>
                            {[
                              permAddrData?.address1,
                              permAddrData?.address2,
                              permAddrData?.address3
                            ]
                              .filter(Boolean)
                              .join(" ") || "No Address Available"}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Pincode :</strong>
                          <span>{permAddrData?.zip || "N/A"}</span>
                        </td>
                        <td>
                          <strong>State :</strong>
                          <span>{permAddrData?.state || "N/A"}</span>
                        </td>
                        <td>
                          <strong>City :</strong>
                          <span>{permAddrData?.city || "N/A"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Nationality:</strong>
                          <span>{permAddrData?.nationality || "N/A"}</span>
                        </td>
                        <td>
                          <strong>Country :</strong>
                          <span>{permAddrData?.country || "N/A"}</span>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Emergency Contact No :</strong>
                          <span>
                            {permAddrData?.emergencyContactNumber || "N/A"}
                          </span>
                        </td>
                        <td>
                          <strong>Their name with relation :</strong>
                          <span>
                            {permAddrData?.emergencyContactName || "N/A"}
                          </span>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* If sameAsPermanentAddress is true, show heading and text inline */}
                {currAddrData?.sameAsPermanentAddress ? (
                  <h6 style={{ margin: "10px 10px -2px 10px" }}>
                    Current Address :{" "}
                    <span style={{ fontWeight: "normal" }}>
                      Same As Permanent Address
                    </span>
                  </h6>
                ) : (
                  <>
                    <h6 style={{ margin: "10px 10px -7px 10px" }}>
                      Current Address :
                    </h6>
                    <div className="preview-table">
                      <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <strong>Address :</strong>
                              <span>
                                {[
                                  currAddrData?.address1,
                                  currAddrData?.address2,
                                  currAddrData?.address3
                                ]
                                  .filter(Boolean)
                                  .join(" ") || "No Address Available"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Pincode :</strong>
                              <span>{currAddrData?.zip || "N/A"}</span>
                            </td>
                            <td>
                              <strong>State :</strong>
                              <span>{currAddrData?.state || "N/A"}</span>
                            </td>
                            <td>
                              <strong>City :</strong>
                              <span>{currAddrData?.city || "N/A"}</span>
                            </td>
                          </tr>
                          <tr>
                            {/* <td>
                              <strong>Nationality:</strong>
                              <span>{addresses?.[1]?.nationality || "N/A"}</span>
                            </td> */}
                            <td>
                              <strong>Country :</strong>
                              <span>{currAddrData?.country || "N/A"}</span>
                            </td>
                            <td></td>
                          </tr>

                          <tr>
                            <td>
                              <strong>Emergency Contact No :</strong>
                              <span>
                                {currAddrData?.emergencyContactNumber ||
                                  "N/A"}
                              </span>
                            </td>
                            <td>
                              <strong>Their name with relation :</strong>
                              <span>
                                {currAddrData?.emergencyContactName || "N/A"}
                              </span>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
              <div className="personalDetailForm">
                <div className="personalDetailHeading">
                  <h6 className="personalDetailHeadline">
                    EDUCATIONAL DETAILS
                  </h6>
                </div>
                <div className="preview-table addressHistory">
                  <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Degree/Qualification Name</strong>
                        </td>
                        <td>
                          <strong>College / Institute Name</strong>
                        </td>
                        <td>
                          <strong>Location</strong>
                        </td>
                        <td>
                          <strong>Field Of Study</strong>
                        </td>
                        <td>
                          <strong>Duration</strong>
                        </td>
                        <td>
                          <strong>Roll No</strong>
                        </td>
                        <td>
                          <strong>Grade/Percentage</strong>
                        </td>
                        <td>
                          <strong>Attachments</strong>
                        </td>
                      </tr>
                      {educationDetails?.length > 0 ? (
                        educationDetails.map((education, index) => {
                          let formattedDuration = "";

                          if (education?.fromDate && education?.toDate) {
                            const startDate = parseISO(education.fromDate);
                            const endDate = parseISO(education.toDate);

                            if (startDate.getTime() && endDate.getTime()) {
                              const duration = intervalToDuration({
                                start: startDate,
                                end: endDate,
                              });

                              formattedDuration = `${duration.years || 0} Years, ${duration.months || 0} Months`;
                            } else {
                              formattedDuration = "Invalid Date Range";
                            }
                          } else {
                            formattedDuration = "N/A";
                          }

                          let uploadType = "";

                          if (index === 0) {
                            uploadType = "10thMarksheet";
                          } else if (index === 1) {
                            uploadType = "12thMarksheet";
                          } else {
                            uploadType = `${education.degreeName}Certificate`;
                          }
                          return (
                            <tr key={education.id}>
                              <td>{education.degreeName || "N/A"}</td>
                              <td>{education.institutionName || "N/A"}</td>
                              <td>{education.location || "N/A"}</td>
                              <td>{education.fieldOfStudy || "N/A"}</td>
                              <td>{formattedDuration}</td>
                              <td>{education.rollNumber || "N/A"}</td>
                              <td>{education.gradeOrcgpa || "N/A"}</td>
                              <td>
                                <span>
                                  {docs[uploadType] ? (
                                    <a
                                      href={docs[uploadType]}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8"></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {employmentHistory?.length > 0 ? (
                  <>
                    <h6 style={{ marginTop: "10px", margin: "10px 10px 0" }}>
                      Employment History :
                    </h6>
                    {employmentHistory.map((employment, index) => {
                      const formatDate = (str) => str ? new Date(str).toLocaleDateString('en-GB') : "";
                      const fromDate = formatDate(employment.employmentPeriodFrom);
                      const toDate = formatDate(employment.employmentPeriodTo);
                      const empHistoryPeriodOfStay = fromDate && toDate ? `${fromDate} - ${toDate}` : "N/A";
                      return (
                        <div className="preview-table" key={employment.id}>
                          <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                            <tbody>
                              <tr key={employment.id}>
                                <td
                                  style={{ width: "40px", textAlign: "center" }}
                                >
                                  <strong>{index + 1}.</strong>
                                </td>
                                <td>
                                  <strong>Previous Employer Name :</strong>
                                  <span>
                                    {employment.previousEmployerName || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>Employee Code :</strong>
                                  <span>
                                    {employment.employeeCode || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>Office Phone No :</strong>
                                  <span>
                                    {employment.mobileNumber || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>Designation :</strong>
                                  <span>{employment.designation || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  <strong>Department :</strong>
                                  <span>{employment.department || "N/A"}</span>
                                </td>
                                <td>
                                  <strong>Reasons For Leaving :</strong>
                                  <span>
                                    {employment.reasonForLeaving || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>Employment Period :</strong>
                                  <span>{empHistoryPeriodOfStay}</span>
                                </td>
                                <td>
                                  <strong>Position :</strong>
                                  <span>
                                    {employment.positionType || "N/A"}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  <strong>{"Manager's Name :"}</strong>
                                  <span>{employment.managerName || "N/A"}</span>
                                </td>
                                <td>
                                  <strong>{"Manager's Contact No :"}</strong>
                                  <span>
                                    {employment.managerContactNo || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>{"Manager's Email ID :"}</strong>
                                  <span>
                                    {employment.managerEmail || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>Address :</strong>
                                  <span>{employment.address || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  <strong>
                                    Experience Certificate / Relieving Letter :
                                  </strong>
                                  <span>
                                    {docs[`expCertFile.${index}`]
                                      ? docs[`expCertFile.${index}`] && (
                                        <a
                                          href={docs[`expCertFile.${index}`]}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : "N/A"}
                                  </span>{" "}
                                  ,
                                  <span>
                                    {docs[`relievingLetterFile.${index}`]
                                      ? docs[
                                      `relievingLetterFile.${index}`
                                      ] && (
                                        <a
                                          href={
                                            docs[
                                            `relievingLetterFile.${index}`
                                            ]
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>
                                    Appointment Letter / Offer Letter :
                                  </strong>
                                  <span>
                                    {docs[`offerLetter.${index}`]
                                      ? docs[`offerLetter.${index}`] && (
                                        <a
                                          href={docs[`offerLetter.${index}`]}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <strong>
                                    Last Three Month Salary Slips :
                                  </strong>
                                  <span>
                                    {docs[`lastThreeMonthSalarySlip1.${index}`]
                                      ? docs[
                                      `lastThreeMonthSalarySlip1.${index}`
                                      ] && (
                                        <a
                                          href={
                                            docs[
                                            `lastThreeMonthSalarySlip1.${index}`
                                            ]
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : ""}
                                  </span>
                                  <span>
                                    {docs[`lastThreeMonthSalarySlip2.${index}`]
                                      ? docs[
                                      `lastThreeMonthSalarySlip2.${index}`
                                      ] && (
                                        <a
                                          href={
                                            docs[
                                            `lastThreeMonthSalarySlip2.${index}`
                                            ]
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : ""}
                                  </span>
                                  <span>
                                    {docs[`lastThreeMonthSalarySlip3.${index}`]
                                      ? docs[
                                      `lastThreeMonthSalarySlip3.${index}`
                                      ] && (
                                        <a
                                          href={
                                            docs[
                                            `lastThreeMonthSalarySlip3.${index}`
                                            ]
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : ""}
                                  </span>
                                </td>
                                <td>
                                  <strong>
                                    Last Three Month Bank Statements :
                                  </strong>
                                  <span>
                                    {docs[
                                      `lastThreeMonthBankStatement.${index}`
                                    ]
                                      ? docs[
                                      `lastThreeMonthBankStatement.${index}`
                                      ] && (
                                        <a
                                          href={
                                            docs[
                                            `lastThreeMonthBankStatement.${index}`
                                            ]
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View
                                        </a>
                                      )
                                      : ""}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </>
                ) : (
                <h6 style={{ margin: "10px" }}>
                  Employment History :
                  <span style={{ fontWeight: "normal" }}>
                    {` No Employment History Details`}
                  </span>
                </h6>
                )}
              </div>
              <div className="personalDetailForm">
                <div className="personalDetailHeading">
                  <h6 className="personalDetailHeadline">Additional DETAILS</h6>
                </div>
                {additionalDetails?.passportNumber !== "" ? (
                  <>
                    <h6
                      style={{
                        marginTop: "10px",
                        margin: "10px 10px -7px 10px",
                      }}
                    >
                      Passport Details
                    </h6>
                    <div className="preview-table">
                      <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Passport No. :</strong>
                              <span>
                                {additionalDetails?.passportNumber || "N/A"}
                              </span>
                            </td>
                            <td>
                              <strong>Passport Front Page Image :</strong>
                              <span>
                                {docs["passportFrontImage"]
                                  ? docs["passportFrontImage"] && (
                                    <a
                                      href={docs["passportFrontImage"]}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  )
                                  : "N/A"}
                              </span>
                            </td>
                            <td>
                              <strong>Passport Last Page Image :</strong>
                              <span>
                                {docs["passportLastPageImage"]
                                  ? docs["passportLastPageImage"] && (
                                    <a
                                      href={docs["passportLastPageImage"]}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  )
                                  : "N/A"}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <h6 style={{ marginTop: "10px", margin: "10px 10px 10px" }}>
                    Passport Details :{" "}
                    <span style={{ fontWeight: "normal" }}>
                      No Passport Details Record
                    </span>
                  </h6>
                )}
                {professionalReferences?.length > 0 &&
                  professionalReferences?.[0].isRelative ? (
                  <>
                    <h6 style={{ marginTop: "10px", margin: "10px 10px 0" }}>
                      Relative Working With Moptra Infotech :{" "}
                      <span style={{ fontWeight: "normal" }}>Yes</span>
                    </h6>
                    <div className="preview-table addressHistory">
                      <table className="table table-hover table-vcenter text-nowrap mb-0" role="presentation">
                        <tbody>
                          <tr>
                            <td className="serial-no-column">
                              <strong>S.No.</strong>
                            </td>
                            <td>
                              <strong>Name</strong>
                            </td>
                            <td>
                              <strong>Relationship</strong>
                            </td>
                            <td>
                              <strong>Department</strong>
                            </td>
                            <td>
                              <strong>Designation</strong>
                            </td>
                            <td>
                              <strong>Employee ID</strong>
                            </td>
                          </tr>
                          {professionalReferences &&
                            professionalReferences.map(
                              (relativeInfo, index) => (
                                <tr key={relativeInfo.id}>
                                  <td className="serial-no-column">
                                    <strong>{index + 1}.</strong>
                                  </td>
                                  <td>{relativeInfo?.name || "N/A"}</td>

                                  <td>{relativeInfo?.relationship || "N/A"}</td>
                                  <td>{relativeInfo?.department || "N/A"}</td>
                                  <td>{relativeInfo?.designation || "N/A"}</td>
                                  <td>{relativeInfo?.employeeId || "N/A"}</td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <h6 style={{ marginTop: "10px", margin: "10px 10px 0" }}>
                    Relative Working With Moptra Infotech :{" "}
                    <span style={{ fontWeight: "normal" }}>No</span>
                  </h6>
                )}
                {additionalDetails?.illnessDeclaration ? (
                  <>
                    <h6 style={{ marginTop: "10px", margin: "10px 10px 0" }}>
                      Details Of Any Major Illness/Surgery In The Past 3 Years :{" "}
                      <span style={{ fontWeight: "normal" }}>Yes</span>
                    </h6>
                    <div className="preview-table addressHistory">
                      <table className="table table-hover table-vcenter text-nowrap mb-0">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Details</strong>
                            </td>
                            <td>
                              <strong>Supporting Document</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {additionalDetails?.illnessDeclaration || "N/A"}
                            </td>
                            <td>
                              <span>
                                {docs["illnessDocument"]
                                  ? docs["illnessDocument"] && (
                                    <a
                                      href={docs["illnessDocument"]}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  )
                                  : "N/A"}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                <h6 style={{ margin: "10px 10px 0" }}>
                  Details Of Any Major Illness/Surgery In The Past 3 Years:
                  <span style={{ fontWeight: "normal", marginLeft: "5px" }}>
                    No
                  </span>
                </h6>
                )}
                {additionalDetails?.hobbiesDeclaration ? (
                  <>
                    <div style={{ textAlign: 'left', margin: "20px 10px 20px 10px" }}>
                      <h6>hobbies, interests and professional alignments :</h6>
                      <span style={{ fontWeight: "normal" }}>
                        {additionalDetails?.hobbiesDeclaration}
                      </span>
                    </div>
                  </>
                ) : (
                  <div style={{ textAlign: 'left', margin: "20px 10px 20px 10px" }}>
                    <h6>hobbies, interests and professional alignments :</h6>
                    <span style={{ fontWeight: "normal" }}>Not mentioned</span>
                  </div>
                )}
              </div>
                <div className="personalDetailForm">
                  <div className="personalDetailHeading">
                    <h6 className="personalDetailHeadline">{`Declaration `}</h6>
                  </div>
                  <div className="declaration-container">
                    <ul>
                      <li>
                        I am accepting the defined policies and processes in Moptra Infotech.
                      </li>
                      <li>
                        I also agree that my candidature with Moptra Infotech is valid only till I abide by the policies and processes of Moptra Infotech.
                      </li>
                      <li>
                        I give my consent and authorize Moptra Infotech (or a third party appointed by Moptra Infotech) to contact any former employee as indicated above and carry out all Background checks not restricted to education, employment, database search, address verification, criminal check, reference check deemed appropriate through this selection procedure/continued employment. I authorize my former employers, agencies educational institutes etc. to release any information pertaining to any employment/education and I release them from any liability in doing so.
                      </li>
                      <li>
                        {" "}
                        I have not been charge sheeted for any offense under the CRPC and the IPC or any other criminal Laws in India or any other country. I shall promptly notify Moptra Infotech and the relevant stakeholders, if I am being sheeted for any offense now or any time during my tenure at Moptra Infotech.
                      </li>
                      <li className="declarationCheck">
                        <input id="declareCheck"
                          type="checkbox"
                          className="lastDeclarecheck"
                          checked={additionalDetails?.finalDeclaration??false}
                          readOnly
                        />
                        <label htmlFor="declareCheck">
                          <span className="required">*</span>I hereby declare that all information that I have provided in this form are true to the best of my acknowledge, and that any misrepresentation of information by me will disqualify my candidature and subsequent employment with Moptra Infotech Pvt. Ltd.
                        </label>
                      </li>
                      {errors.declaration && (
                        <div className="declarationErrorMessage">
                          Please check the declaration to proceed further
                        </div>
                      )}
                    </ul>
                  </div>
                </div>
              <div
              
                className="signAttach"
              >
                <div className="personalDetailForm">
                </div>
                <div className="contactSaveButtons justify-content-between">
                  <div className="form-group lastDate col-md-4">     
                    
                    <label htmlFor="date">
                      Date<span className="required">*</span>
                    </label>
                    <div id="date"
                      className={` lastPlaceInput filled-date`}
                      
                    >{formatDate(additionalDetails?.previewDate)}</div>
                  </div>
                  <div className="form-group place col-md-2 justify-content-end">
                    <label htmlFor="Place">
                      Place<span className="required">*</span>
                    </label>
                    
                    <div id="date"
                      className={` lastPlaceInput filled-date`}
                      
                    >{additionalDetails?.place}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
